import { getPublicKeyFromPrivate, publicKeyToBtcAddress } from '@stacks/encryption';
import { HDKey } from '@scure/bip32';
export const HARDENED_OFFSET = 2147483648;
export const getGaiaAddress = (account) => {
    const publicKey = getPublicKeyFromPrivate(account.dataPrivateKey);
    const address = publicKeyToBtcAddress(publicKey);
    return address;
};
export const getRootNode = (wallet) => {
    return HDKey.fromExtendedKey(wallet.rootKey);
};
//# sourceMappingURL=common.js.map